import { useLazyQuery, useQuery } from '@apollo/client';
import {
  ProductCourseMappingsData,
  ProductCourseMappingsFiltersData,
  ProductCourseMappingsInputType,
} from './types';
import {
  ProductCourseMappings,
  ProductCourseMappingsFilters,
} from '../../apollo/queries/productCourseMapping/productMappings.queries';

export const useProductCourseMapping = () => {
  const [fetchAllProductCourseMappings, { data, loading }] = useLazyQuery<
    ProductCourseMappingsData,
    ProductCourseMappingsInputType
  >(ProductCourseMappings, {
    fetchPolicy: 'cache-and-network',
  });
  return {
    productCourseMappingsData: data?.productCourseMappings || {
      mappings: [],
      pageNumber: 0,
      pageSize: 0,
      totalCount: 0,
    },
    fetchAllProductCourseMappings,
    isFetchLoading: loading,
  };
};

export const useProductMappingsFilters = () => {
  const { loading, data } = useQuery<ProductCourseMappingsFiltersData>(
    ProductCourseMappingsFilters,
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  return {
    loading,
    productMappingsFilters: data?.productCourseMappingFilterOptions || {
      createdBy: [],
      productTypes: [],
    },
  };
};

export const useProductCourseMappingTotalCount = () => {
  const { data } = useQuery<ProductCourseMappingsData>(ProductCourseMappings, {
    variables: {
      pageNumber: 0,
      pageSize: 999999,
      search: '',
      productType: '',
      addedBy: '',
    },
    fetchPolicy: 'cache-and-network',
  });
  return data?.productCourseMappings?.totalCount || 0;
};
